import { render } from "./search-geolink.vue?vue&type=template&id=ddf3e79e"
import script from "./search-geolink.vue?vue&type=script&lang=js"
export * from "./search-geolink.vue?vue&type=script&lang=js"

import "./search-geolink.vue?vue&type=style&index=0&id=ddf3e79e&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__